module.exports = __webpack_public_path__ + "img/grinding_1200x800.884a091c.svg";